import React from "react";
import styled, { withTheme } from "styled-components";

const StyledForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const MarketoFormElement = ({ children, id }) => (
  <StyledForm id={id}>{children}</StyledForm>
);

export default withTheme(MarketoFormElement);
